import { ReactNode } from 'react'

import ChartTitle from '@/components/view/atoms/chart/ChartTitle'
import InsideArea, { BgColor } from '@/components/view/layouts/area/InsideArea'

interface Props {
  title: string
  // チャートの高さ（px）。凡例を含めた描画領域
  height?: number
  children: ReactNode
}

// チャートを枠付きの薄い背景で囲むカード。左上にタイトル、右上に凡例（各チャート側）を置く
const GeoChartCard = ({ title, height = 320, children }: Props) => (
  <InsideArea color={BgColor.SECONDARY}>
    <ChartTitle>{title}</ChartTitle>
    <div style={{ height }}>{children}</div>
  </InsideArea>
)

export default GeoChartCard
